import { ActionFunctionArgs } from "react-router";
import { config } from '../../config';
import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';


async function alertAction({ request }: ActionFunctionArgs) {
  try {
    const asset_ids: string[] = (await request.json());

    if (asset_ids && asset_ids.length > 0) {
      const now: Date = new Date();
      const millisecondsIn24Hours: number = 24 * 60 * 60 * 1000;
      const twentyFourHoursAgo: Date = new Date(
        now.getTime() - millisecondsIn24Hours
      );
      const body = JSON.stringify({
        asset_ids,
        since_dt: twentyFourHoursAgo.toISOString(),
      });
      const headers = await prepareHeaders(new Headers());
      
      const response = await fetch(config.backend.SCORES_SERVICE + '/v2/alerts', {
        method: "POST",
        headers,
        body,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return { 
          serverError: true, 
          message: errorData.message || `Status: ${response.status}` 
        };
      }

      return await response.json();
    }
    return [];
  } catch (err: any) {
    return { serverError: true, message: err.message };
  }
}


export { alertAction };